<template>
  <Slide>
    <figure>
      <Seal v-if="inView" class="icon" />
    </figure>
  </Slide>
</template>

<script>
import Slide from '../Slide'
import { Seal } from '../icons'
import { returnCostsSlideMixin, scrollPositionMixin } from '@/mixins'

export default {
  name: 'FifthSlide',
  components: {
    Slide,
    Seal
  },
  mixins: [returnCostsSlideMixin, scrollPositionMixin]
}
</script>

<style lang="scss" scoped>
.icon {
  top: 88px;
  left: 50%;
  transform: translateX(-50%);
  margin: 0 auto;
  position: absolute;
}
</style>
